const carouselItems = [
  {
    title: '韩漫宫廷恋爱特辑',
    desc: '浪漫古装宫廷题材韩漫精选，从我的野蛮王妃到某天成为公主，带你穿越时空感受甜蜜爱恋。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20palace%20illustration%20with%20elegant%20characters%20in%20traditional%20hanbok%2C%20warm%20golden%20lighting%2C%20soft%20cream%20background%2C%20editorial%20composition%2C%20clean%20aesthetic&width=800&height=450&seq=carousel-kr-01&orientation=landscape',
    tag: '韩漫推荐',
  },
  {
    title: '日漫热血冒险专题',
    desc: '进击的巨人、鬼灭之刃等经典日漫全本资源，热血战斗与深刻剧情交织，每一部都是不朽名作。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20adventure%20illustration%20with%20dynamic%20battle%20scene%2C%20warm%20vibrant%20colors%2C%20epic%20composition%2C%20cream%20background%2C%20clean%20editorial%20style&width=800&height=450&seq=carousel-jp-02&orientation=landscape',
    tag: '日漫经典',
  },
  {
    title: '国漫玄幻巅峰之作',
    desc: '斗破苍穹、完美世界、绝世武魂等国产玄幻漫画头部作品全本收录，国风美学与热血剧情完美融合。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20martial%20arts%20illustration%20with%20flowing%20ink%20wash%20style%2C%20mythological%20elements%2C%20warm%20earth%20tones%2C%20cream%20background%2C%20elegant%20editorial%20composition&width=800&height=450&seq=carousel-cn-03&orientation=landscape',
    tag: '国漫崛起',
  },
  {
    title: '全本完结一口气看完',
    desc: '超过万部全本完结漫画一次收藏，免去追更等待之苦，从第一话看到大结局，满足你的阅读渴望。',
    img: 'https://readdy.ai/api/search-image?query=Stack%20of%20colorful%20completed%20comic%20book%20collections%20displayed%20artistically%2C%20warm%20golden%20lighting%2C%20cream%20background%2C%20clean%20editorial%20photography%20style%2C%20cozy%20atmosphere&width=800&height=450&seq=carousel-complete-04&orientation=landscape',
    tag: '全本免费',
  },
  {
    title: '恋爱甜宠漫画合辑',
    desc: '治愈系恋爱漫画大合集，从校园青涩到都市成熟，每一段爱情故事都让人心动不已，甜到停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20style%20illustration%20with%20couple%20in%20cherry%20blossom%20scene%2C%20soft%20pink%20and%20warm%20tones%2C%20sweet%20atmosphere%2C%20cream%20background%2C%20clean%20editorial%20composition&width=800&height=450&seq=carousel-romance-05&orientation=landscape',
    tag: '甜宠推荐',
  },
  {
    title: '悬疑推理烧脑专区',
    desc: '高智商悬疑推理漫画精选，层层反转的剧情让你欲罢不能，每翻一页都是新的震撼与惊喜。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20style%20illustration%20with%20shadowy%20detective%20scene%2C%20warm%20amber%20lighting%2C%20dramatic%20composition%2C%20cream%20background%2C%20clean%20editorial%20aesthetic&width=800&height=450&seq=carousel-mystery-06&orientation=landscape',
    tag: '悬疑推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-sparkling-line text-sm"></i>
              编辑精选
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              编辑团队精心挑选的优质漫画专题，每一部都是不可错过的精彩作品
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {carouselItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden bg-background-100">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block text-[10px] font-semibold text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full mb-2.5">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}